import { jsx as _jsx } from "react/jsx-runtime";
import { verificationMap, t } from '@cwos/ui-shared';
import { Pill } from './Pill';
export function VerificationBadge({ verification, geofenceName, firstName, }) {
    const entry = verificationMap[verification];
    let copyKey = entry.copyKey;
    const params = {};
    if (verification === 'verified_inside' && geofenceName) {
        copyKey = 'verify.atGeofence';
        params.geofence = geofenceName;
    }
    if (verification === 'attested_by_worker' && firstName) {
        params['first name'] = firstName;
    }
    return (_jsx(Pill, { variant: entry.variant, dot: true, children: t(copyKey, params) }));
}
//# sourceMappingURL=VerificationBadge.js.map